/* global axios */
import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  getAiAgents() {
    return axios.get(`${this.url}?type=ai_agent`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  getMetrics(id) {
    return axios.get(`${this.url}/${id}/metrics`);
  }

  testMessage(id, content) {
    return axios.post(`${this.url}/${id}/test_message`, { content });
  }
}

export default new AiAgentsAPI();
